import { graphql } from "@opensea/graphql"
import { CollectionPreviewTooltipContentFragment } from "@/components/collection/CollectionPreviewTooltip/CollectionPreviewTooltipContent.fragment"
import { collectionUrlFragment } from "@/components/collection/utils"

export const CollectionCurrencyPreviewSheetFragment = graphql(
  `
    fragment CollectionCurrencyPreviewSheet on Currency {
      collections {
        ...CollectionPreviewTooltipContent
        ...collectionUrl
      }
    }
  `,
  [CollectionPreviewTooltipContentFragment, collectionUrlFragment],
)
